/* template */
<template minapp="mpx" xlang="wxml"><es-drawer-bottom title="截止时间" :show="(show)" showDefaultNav @close="closeDeadline" :customStyle="(curCustomStyle)" class="main"><div class="deadline-drawer-container"><div class="deadline-select-group"><mpx-view :class="({'deadline-select-item-selected': curDeadLine === item.hour})" v-for="(item, index) in (refactorDeadLineList)" :key="item['item.hour']" @tap="setCurDeadLine(item)" class="deadline-select-item">{{ item.text }}</mpx-view></div><div class="deadline-warning"><mpx-image src="https://img-hxy021.didistatic.com/static/starimg/img/xzlfGbV4NI1692120398899.png" class="warning-icon"/><span class="warning-text">到期未抢到票，订单自动取消，票款原路退回</span></div><mpx-view @tap="setSelectDeadLine" class="deadline-button">确认</mpx-view></div></es-drawer-bottom></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m37c96134"}'>
  .deadline-drawer-container
    padding 4px 0 34px 0
    .deadline-select-group
      display grid
      grid-template-columns 170px 170px
      grid-template-rows 37px 37px
      grid-column-gap 11px
      grid-row-gap 10px
      justify-content center
      margin-bottom 24px
      .deadline-select-item
        width 170px
        height 37px
        border-radius 8px
        background #F6F8FA
        font-family PingFangSC-Regular
        font-size 14px
        line-height 37px
        text-align center
        color #333333
        box-sizing border-box
        &-selected
          border 1px solid #FF5900
          background rgba(254, 245, 234, 0.5)
          font-family PingFangSC-Medium
          color #000
    .deadline-warning
      width 100%
      display flex
      background linear-gradient(0deg, #FFF6F1, #FFF6F1), linear-gradient(270deg, #FFFFFF 3%, #FFF3EB 100%)
      padding 12px 0 14px 20px
      box-sizing border-box
      .warning-icon
        height 14px
        width 14px
        margin-right 5px
      .warning-text
        font-family PingFangSC-Regular
        font-size 12px
        line-height 14px
        color #333
    .deadline-button
      width 351px
      height 48px
      border-radius 8px
      background #FF6400
      margin 16px auto 0 auto
      line-height 48px
      font-size 17px
      font-family PingFangSC-Medium
      color #fff
      text-align center
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m37c96134"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./deadline-drawer.mpx.js?isComponent&outputPath=components%2Fdeadline-drawer37c96134%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./deadline-drawer.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fdeadline-drawer37c96134%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m37c96134"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/deadline-drawer37c96134/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'es-drawer-bottom':getComponent(require("../../../../node_modules/@didi/es-mpx-ui/lib/drawer-bottom/index.mpx?isComponent&outputPath=components%2Findexeb3fdc9e%2Findex")),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
